import { React, useState, useEffect } from "react";
import { Button, Form, Icon, Modal, Grid } from "semantic-ui-react";

import { isEmpty, map, find, subtract } from "lodash";

import PropTypes from "prop-types";
import Joi from "joi";

// Components
import Input from "@Components/Input";

// Styles
import styles from "./styles.module.css";

const AlertTimes = ({ alertTimesHandler, data, onClose, tableValue }) => {
	AlertTimes.propTypes = {
		tableValue: PropTypes.object,
		alertTimesHandler: PropTypes.func,
		onClose: PropTypes.func,
	};

	// hooks
	const [errors, setErrors] = useState([{ time: "" }]);
	const [limitMax, setLimitMax] = useState(9999);
	const [limitMin, setLimitMin] = useState(0);

	const [formData, setFormData] = useState({});
	const schema = Joi.object().keys({
		time: Joi.number()
			.min(subtract(limitMin.time, 1))
			.max(subtract(limitMax.time, 1))
			.messages({
				"number.base": "Tiempo es un campo requerido",
				"number.min": `El número tiene que ser mayor que ${limitMin.time} (${limitMin.name})`,
				"number.max": `El número tiene que ser menor que ${limitMax.time} (${limitMax.name})`,
			}),
	});

	// Effects

	useEffect(() => {
		if (tableValue) {
			let backwardness = {};
			let onTime = {};
			let defeated = {};

			switch (tableValue.name) {
				case "Vencido": {
					backwardness = find(data, { name: "En Atraso" });
					setLimitMin(backwardness);

					setLimitMax({ name: "Maximo", time: 9999, color: "red" });
					break;
				}
				case "En Atraso": {
					onTime = find(data, { name: "A Tiempo" });
					defeated = find(data, { name: "Vencido" });
					setLimitMin(onTime);

					setLimitMax(defeated);
					break;
				}
				case "A Tiempo": {
					backwardness = find(data, { name: "En Atraso" });
					setLimitMin({ name: "Minimo", time: 0, color: "red" });
					setLimitMax(backwardness);
					break;
				}
				default:
					return "";
			}

			setFormData(tableValue);
		}
	}, [tableValue]);

	// input handlers
	const handleInput = (e, { name, value }) => {
		setFormData({
			...formData,
			[name]: isEmpty(value) ? 0 : parseInt(value, 10),
		});
	};

	// saveHandlers
	const save = () => {
		const validation = schema.validate({ time: formData.time }, { abortEarly: false });
		if (validation.error) {
			const { details } = validation.error;
			let errorsVal = {
				time: "",
			};
			map(details, (item) => {
				errorsVal = { ...errorsVal, [item.context.key]: item.message };
			});
			setErrors(errorsVal);
		} else {
			alertTimesHandler(formData);
			onClose();
		}
	};

	return (
		<div>
			<Modal
				centered={false}
				open
				closeIcon
				className={styles.modal}
				onClose={() => {
					onClose();
				}}>
				<Modal.Header className={styles.modalHeader}>
					<Icon name="edit" />
					{`Alerta - ${tableValue.name}`}
				</Modal.Header>
				<Modal.Content className={styles.modalContent} scrolling>
					<Form noValidate>
						<Grid columns={1}>
							<Grid.Column width={16} className={styles.column}>
								<Grid.Row className={styles.row}>
									<Form.Field className={styles.field} style={{ width: "100%" }}>
										<Input
											value={String(formData.time)}
											icon="clock"
											type="number"
											name="time"
											label="Tiempo en minutos"
											required
											fluid
											error={!isEmpty(errors.time) && { content: errors.time, pointing: "above" }}
											onChange={handleInput}
											className={styles.classTime}
										/>
									</Form.Field>
									{/* <Label className={styles.messageError} style={isEmpty(errors.name) ? { display: "none" } : null} prompt>
                    {errors.name}
                  </Label> */}
								</Grid.Row>
							</Grid.Column>
						</Grid>
					</Form>
				</Modal.Content>
				<Modal.Actions className={styles.modalAction}>
					<Button
						className={styles.negativeButton}
						onClick={() => {
							onClose();
						}}>
						Atrás
					</Button>
					<Button
						className={styles.positiveButton}
						onClick={() => {
							save();
						}}>
						Modificar
					</Button>
				</Modal.Actions>
			</Modal>
		</div>
	);
};
AlertTimes.propTypes = {
	alertTimesHandler: PropTypes.func,
	data: PropTypes.array,
	onClose: PropTypes.func,
	tableValue: PropTypes.array,
};
export default AlertTimes;
